export const EMAIL_REGEXP = new RegExp('^[a-z0-9._%+-]{1,64}@(?:[a-z0-9-]{1,63}.){1,125}[a-z]{2,63}$');
